import {Footer} from "react-navigationbar";
import { AFREECATV_URL, STATION_URL } from "constant/config";
import { isWebview } from "helpers";
import React from "react";
import { Trans } from "react-i18next";

export const StationError = (props) => {
	const { error } = props;
	const afreecaLink = isWebview ? "onlive://browser/close" : AFREECATV_URL;
	switch (error.code) {
		case 9000: //방송국없음
		case 9001: //블라인드
			return [
				<div key={0} id="bs-container">
					<div id="bs-contents" className="bs_status">
						<article>
							<h2>
								<Trans>Blog không tồn tại.</Trans>
							</h2>
							<p>
								<Trans>Địa chỉ Blog này chưa được tạo hoặc địa chỉ có thể không chính xác.</Trans>
							</p>
							<a href={afreecaLink} className="btn-basic blue">
								<span>
									<Trans>Trở về trang chủ</Trans>
								</span>
							</a>
						</article>
					</div>
				</div>,
				<Footer key={1} className="full" />,
			];
		case 9002: //휴면
			return [
				<div key={0} id="bs-container">
					<div id="bs-contents" className="bs_status">
						<article>
							<h2>
								<Trans>tương ứng Người dùng ngủ đông Nó là một trạng thái.</Trans>
							</h2>
							<p>
								<Trans>người dùng Tôi Theo yêu cầu Trạm thu phát thông tin ngủ đông Nó là một trạng thái.</Trans>
								<br />
								<Trans>ngủ đông Phát hành Nếu bạn muốn Là một trung tâm khách hàng Cuộc điều tra Cho đi ước.</Trans>
							</p>
							<a href={afreecaLink} className="btn-basic blue">
								<span>
									<Trans>Trở về trang chủ</Trans>
								</span>
							</a>
						</article>
					</div>
				</div>,
				<Footer key={1} className="full" />,
			];
		case 9003: // 에러
			console.log("bj_id", global.bj_id);
			return [
				<div key={0} id="bs-container">
					<div id="bs-contents" className="bs_status">
						<article>
							<h2>
								<Trans>Trang không tồn tại.</Trans>
							</h2>
							<p>
								<Trans>Địa chỉ trang bạn muốn truy cập không chính xác hoặc bị lỗi, vui lòng kiểm tra và thử lại.</Trans>
								<br />
								<Trans></Trans>
							</p>
							<a href={`${STATION_URL}/${global.bj_id}`} className="btn-basic blue">
								<span>Quay về Blog</span>
							</a>
						</article>
					</div>
				</div>,
			];
		case 9100: //휴면
			return [
				<div key={0} id="bs-container">
					<div id="bs-contents" className="bs_status">
						<article className="stop">
							<h2>
								<Trans>Blog này hiện đang bị khóa</Trans>
							</h2>
							<p>
								<Trans>Blog đang trong thời gian bị khóa do vi phạm.</Trans>
							</p>
							<div className="stop_reason">
								<ul>
									<li>
										<strong>
											<Trans>Ngày khóa</Trans>&nbsp;
										</strong>
										{error.black.regist_date}
									</li>
									<li>
										<strong>
											<Trans>Ngày mở</Trans>&nbsp;
										</strong>
										{error.black.expire_date}
									</li>
									<li>
										<strong>
											<Trans>Thời gian khóa</Trans>&nbsp;
										</strong>
										{error.black.regist_term}
									</li>
									<li>
										<strong>
											<Trans>Lý do khóa</Trans>&nbsp;
										</strong>
										{error.black.reason}
									</li>
								</ul>
							</div>
							<a href={afreecaLink} className="btn-basic blue">
								<span>
									<Trans>Trở về trang chủ</Trans>
								</span>
							</a>
						</article>
					</div>
				</div>,
				<Footer key={1} className="full" />,
			];
		case 1300://방송국 블랙리스트
			return [
				<div key={0} id="bs-container">
					<div id="bs-contents" className="bs_status">
						<article className="stop">
							<h2>{error.message}</h2>
							<a href={afreecaLink} className="btn-basic blue">
								<span>
									<Trans>Trở về trang chủ</Trans>
								</span>
							</a>
						</article>
					</div>
				</div>,
				<Footer key={1} className="full" />,
			];
		default:
			return [
				<div key={0} id="bs-container">
					<div id="bs-contents" className="bs_status">
						<article>
							<p>{error.message}</p>
							<a href={afreecaLink} className="btn-basic blue">
								<span>
									<Trans>Trở về trang chủ</Trans>
								</span>
							</a>
						</article>
					</div>
				</div>,
				<Footer key={1} className="full" />,
			];
	}
};
